import { useEffect, useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { CustomSelect, FilterOptions } from "../../../../../../../_helpers/Helpers";
import * as actions from "../../../../_redux/person-assignment/PersonAssignmentAction";
import { useTeachersUIContext } from "../TeachersUIContext";

const prepareFilter = (queryParams, values) => {
  let { name, surname, branchId, mobilePhone1, email1 } = values;
  const newQueryParams = { ...queryParams };
  const filter = { name, surname, branchId, mobilePhone1, email1 };
  newQueryParams.filter = filter;
  return newQueryParams;
};

export function TeachersFilter() {
  // Teachers UI Context
  const teachersUIContext = useTeachersUIContext();
  const teachersUIProps = useMemo(() => {
    return {
      queryParams: teachersUIContext.queryParams,
      setQueryParams: teachersUIContext.setQueryParams
    };
  }, [teachersUIContext]);

  const dispatch = useDispatch();
  const { branches } = useSelector(
    (state) => ({
      branches: state.personAssignment.filters
    }),
    shallowEqual
  );
  
  useEffect(() => {
    dispatch(actions.getBranches());
  }, [dispatch]);

  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(teachersUIProps.queryParams, values);
    if (!isEqual(newQueryParams, teachersUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      teachersUIProps.setQueryParams(newQueryParams);
    }
  };
  
  const branchOptions = FilterOptions.concat(branches);

  return (
    <Formik
      initialValues={{        
        name: "",
        surname: "",
        mobilePhone1: "",
        email1: ""
      }}
      onSubmit={(values) => {
        applyFilter(values);
      }}
    >
      {({
        values,
        handleSubmit,
        handleBlur,
        setFieldValue,
      }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <div className="form-group row">
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="name"
                placeholder="Adı"
                onBlur={handleBlur}
                value={values.name}
                onChange={(e) => {
                  setFieldValue("name", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Adı</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="surname"
                placeholder="Soyadı"
                onBlur={handleBlur}
                value={values.surname}
                onChange={(e) => {
                  setFieldValue("surname", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Soyadı</b>
              </small>
            </div>
            <div className="col-lg-2">
              <CustomSelect 
                options={branchOptions}
                value={values.branchId}
                placeholder="Branşı"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("branchId", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Branşı</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="mobilePhone1"
                placeholder="Telefon"
                onBlur={handleBlur}
                value={values.mobilePhone1}
                onChange={(e) => {
                  setFieldValue("mobilePhone1", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Telefon</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="email1"
                placeholder="Email"
                onBlur={handleBlur}
                value={values.email1}
                onChange={(e) => {
                  setFieldValue("email1", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Email</b>
              </small>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
}